import React from 'react';


export const Webpack = props => {
    return (
        <svg className={props.className} width="32" height="32" viewBox="0 0 32 32" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path d="M15.9999 2.04297L3.8999 9.03197V23.011L15.9999 30L28.1059 23.011V9.03197L15.9999 2.04297Z"
                  fill="url(#paint0_radial_364_2)"/>
            <path d="M16 9.13281L10 12.5998V19.5318L16 22.9998L22 19.5338V12.5998L16 9.13281Z" fill="#6F95DB"/>
            <path
                d="M15.9999 2L3.8689 9.037L15.9999 15.642L28.1309 9.08L15.9999 2ZM15.9999 16.548L3.8689 22.981L15.9999 29.974L28.0879 22.937L15.9999 16.548V16.548Z"
                fill="white" fillOpacity="0.1"/>
            <defs>
                <radialGradient id="paint0_radial_364_2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                                gradientTransform="translate(15.9046 15.1613) scale(12.9451 14.9477)">
                    <stop stopColor="#93B4E7"/>
                    <stop offset="0.593" stopColor="#B9D1F8"/>
                    <stop offset="1" stopColor="#9CB6E0"/>
                </radialGradient>
            </defs>
        </svg>
    )
};
